import { useChatAI } from "./chat-ai-context";
import { cx } from "@/utils/cx";
import { sizes } from "@/components/base/select/select";
import { useTranslation } from "react-i18next";

export const AICTACard = () => {
    const { t } = useTranslation(['common']);
    const { openDrawer } = useChatAI();
    return (
        <button
            type="button"
            onClick={openDrawer}
            className={cx(
                "group relative flex items-center gap-3 overflow-hidden rounded-md px-4 py-3 text-left text-white shadow-xs ring-1 ring-inset ring-border-secondary transition",
            )}
            style={{ background: "linear-gradient(135deg, var(--color-brand-700) 0%, var(--color-brand-500) 100%)" }}
        >
            {/* Blurry animated bubble */}
            <span
                aria-hidden
                className="pointer-events-none absolute -top-12 -right-10 h-40 w-40"
                style={{
                    animation: "var(--animate-marquee)",
                }}
            />

            <span className="relative inline-flex size-7 items-center justify-center">
                <img src="/icons/ICO-ask-eve.svg" alt="Ask Eve" className="size-6" />
            </span>
            <span className="relative flex flex-1 items-center justify-between text-sm">
                <span className="font-medium">{t('aiChat.title')}</span>
                <kbd
                    className={cx(
                        "ui-shortcut px-1 py-px text-xs font-body rounded bg-white/[.08] text-white select-none",
                        sizes.sm.shortcut,
                    )}
                    aria-hidden="true"
                >
                    ⌘⇧A
                </kbd>
            </span>
        </button>
    );
};


